import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { Link } from 'react-router-dom';

const RelatedServices = [
  { title: 'Title Searches', path: '/services/title-searches' },
  { title: 'Residential Settlements', path: '/services/residential-settlements' },
  { title: 'Lien Searches', path: '/services/lien-searches' },
  { title: 'Commercial Closings', path: '/services/commercial-closings' },
];

const TitleInsurancePage = () => {
  return (
    <>
      <head>
        <title>Title Insurance Bucks County PA | Black Dog Settlement</title>
        <meta name="description" content="Owner's and lender's title insurance policies in Bucks, Montgomery, Chester, and Delaware County, PA. Protect your real estate investment from hidden defects and liens. Call 215-499-0796." />
        <meta name="keywords" content="title insurance Bucks County PA, owner title insurance Newtown PA, lender title insurance Montgomery County, title protection Chester County Pennsylvania" />
        <link rel="canonical" href="https://www.blackdogsettlement.com/services/title-insurance" />
        <meta name="geo.region" content="US-PA" />
        <meta name="geo.placename" content="Newtown, Pennsylvania" />
        <link href="https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@600;700;800;900&family=Inter:wght@400;500;600;700&display=swap" rel="stylesheet" />
      </head>
      <div style={{ fontFamily: "'Inter', sans-serif" }}>
        <Navbar />

        <section className="bg-[#0f0f0f] pt-36 pb-20">
          <div className="max-w-7xl mx-auto px-6 md:px-12">
            <div className="flex items-center gap-2 text-stone-500 text-xs mb-8">
              <Link to="/" className="hover:text-[#c9a84c] cursor-pointer">Home</Link>
              <i className="ri-arrow-right-s-line"></i>
              <Link to="/services" className="hover:text-[#c9a84c] cursor-pointer">Services</Link>
              <i className="ri-arrow-right-s-line"></i>
              <span className="text-white/40">Title Insurance</span>
            </div>
            <div className="flex items-center gap-3 mb-5">
              <div className="w-8 h-px bg-[#c9a84c]"></div>
              <span className="text-[#c9a84c] text-xs font-bold tracking-[0.3em] uppercase">Service</span>
            </div>
            <h1 className="text-5xl md:text-6xl font-black text-white leading-tight mb-6" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              Title<br /><span className="text-[#c9a84c]">Insurance</span>
            </h1>
            <p className="text-white/40 text-base leading-relaxed max-w-xl">
              Comprehensive owner's and lender's title insurance protecting your Pennsylvania real estate investment from hidden defects, liens, and ownership disputes.
            </p>
          </div>
        </section>

        <section className="bg-white py-20">
          <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col lg:flex-row gap-16">
            <div className="w-full lg:w-[65%]">
              <div className="mb-10 overflow-hidden h-[380px]">
                <img
                  src="https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=1000&h=500&fit=crop&q=80"
                  alt="Title insurance documents - Black Dog Settlement Bucks County PA"
                  className="w-full h-full object-cover object-top"
                />
              </div>

              <h2 className="text-3xl font-black text-[#0f0f0f] mb-5" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                Protect Your Investment with Title Insurance
              </h2>
              <div className="space-y-4 text-stone-500 text-sm leading-relaxed mb-10">
                <p>
                  Title insurance is one of the most important protections you can have when purchasing real estate in Pennsylvania. Unlike other types of insurance that protect against future events, title insurance protects against past events — hidden defects in the title that may not be discovered until after closing.
                </p>
                <p>
                  Black Dog Settlement works with leading title insurance underwriters to provide both owner's and lender's policies for residential and commercial properties throughout Bucks, Montgomery, Chester, and Delaware County, PA.
                </p>
                <p>
                  A one-time premium paid at closing provides lifetime coverage for as long as you own the property — protecting you from claims arising from forgery, fraud, undisclosed heirs, recording errors, and more.
                </p>
              </div>

              {/* Two policy types */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10">
                <div className="border border-stone-100 p-6">
                  <div className="w-10 h-10 flex items-center justify-center border border-[#c9a84c] mb-4">
                    <i className="ri-user-line text-[#c9a84c]"></i>
                  </div>
                  <h3 className="font-black text-[#0f0f0f] text-base mb-3" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Owner's Policy</h3>
                  <p className="text-stone-400 text-sm leading-relaxed mb-4">Protects the buyer's equity in the property for as long as they own it. Covers claims from events that occurred before the purchase.</p>
                  <ul className="space-y-2">
                    {['Forgery & fraud protection', 'Undisclosed heirs', 'Recording errors', 'Boundary disputes', 'Unpaid prior liens'].map(i => (
                      <li key={i} className="flex items-center gap-2 text-xs text-stone-500">
                        <div className="w-3 h-3 flex items-center justify-center shrink-0">
                          <i className="ri-check-line text-[#c9a84c]"></i>
                        </div>
                        {i}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="border border-stone-100 p-6">
                  <div className="w-10 h-10 flex items-center justify-center border border-[#c9a84c] mb-4">
                    <i className="ri-bank-line text-[#c9a84c]"></i>
                  </div>
                  <h3 className="font-black text-[#0f0f0f] text-base mb-3" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Lender's Policy</h3>
                  <p className="text-stone-400 text-sm leading-relaxed mb-4">Required by most mortgage lenders, this policy protects the lender's interest in the property up to the loan amount.</p>
                  <ul className="space-y-2">
                    {["Protects lender's mortgage interest", 'Required for most financed purchases', 'Covers loan amount only', 'Does not protect buyer equity', 'Separate from owner\'s policy'].map(i => (
                      <li key={i} className="flex items-center gap-2 text-xs text-stone-500">
                        <div className="w-3 h-3 flex items-center justify-center shrink-0">
                          <i className="ri-check-line text-[#c9a84c]"></i>
                        </div>
                        {i}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>

            <div className="w-full lg:w-[35%] space-y-6">
              <div className="bg-[#0f0f0f] p-8">
                <h3 className="text-white text-xl font-black mb-3" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Get Title Insurance</h3>
                <p className="text-white/40 text-sm mb-6">Protect your investment. Contact us today for title insurance in Bucks, Montgomery, Chester, or Delaware County.</p>
                <a href="tel:2154990796" className="flex items-center justify-center gap-2 w-full bg-[#c9a84c] hover:bg-[#b8963e] text-[#0f0f0f] font-bold py-3.5 text-xs tracking-[0.15em] uppercase whitespace-nowrap cursor-pointer transition-colors mb-3">
                  <div className="w-4 h-4 flex items-center justify-center"><i className="ri-phone-line"></i></div>
                  Call 215-499-0796
                </a>
                <Link to="/contact" className="flex items-center justify-center w-full border border-white/20 hover:border-white/50 text-white font-bold py-3.5 text-xs tracking-[0.15em] uppercase whitespace-nowrap cursor-pointer transition-colors">
                  Send a Message
                </Link>
              </div>
              <div className="border border-stone-100 p-6">
                <h4 className="text-xs font-bold tracking-[0.2em] uppercase text-stone-400 mb-4">Related Services</h4>
                <div className="space-y-2">
                  {RelatedServices.map((s) => (
                    <Link key={s.path} to={s.path} className="flex items-center justify-between py-2.5 border-b border-stone-100 last:border-0 text-sm text-[#0f0f0f] hover:text-[#c9a84c] transition-colors cursor-pointer group">
                      {s.title}
                      <div className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line text-xs text-stone-300 group-hover:text-[#c9a84c] transition-colors"></i></div>
                    </Link>
                  ))}
                </div>
              </div>
              <div className="bg-[#f7f5f0] p-6 space-y-3">
                <p className="text-xs font-bold tracking-[0.2em] uppercase text-stone-400 mb-4">Contact Info</p>
                <div className="flex items-center gap-3 text-sm text-stone-500"><div className="w-4 h-4 flex items-center justify-center shrink-0"><i className="ri-map-pin-2-line text-[#c9a84c]"></i></div>842 Durham Rd, Newtown, PA 18940</div>
                <div className="flex items-center gap-3 text-sm text-stone-500"><div className="w-4 h-4 flex items-center justify-center shrink-0"><i className="ri-time-line text-[#c9a84c]"></i></div>Mon–Fri: 9AM–5PM</div>
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </div>
    </>
  );
};

export default TitleInsurancePage;
